import { render, staticRenderFns } from "./SidTransform.vue?vue&type=template&id=46114ebf"
import script from "./SidTransform.vue?vue&type=script&lang=js"
export * from "./SidTransform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports